import { render, staticRenderFns } from "./memberList.vue?vue&type=template&id=24571dc8&scoped=true&"
import script from "./memberList.vue?vue&type=script&lang=js&"
export * from "./memberList.vue?vue&type=script&lang=js&"
import style0 from "./memberList.vue?vue&type=style&index=0&id=24571dc8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24571dc8",
  null
  
)

component.options.__file = "memberList.vue"
export default component.exports